import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getItem, LocalLanguage } from '../utils/localStorage';

export default function Footer() {
  const [langauge, setLanguage] = useState('');
  useEffect(() => {
    const lan = getItem(LocalLanguage);
    setLanguage(lan);
  }, []);
  return (
    <footer className="w-full px-4 sm:px-20 mt-10 text-xs text-N6">
      {langauge === 'en' ? (
        <>
          <p>Digital Nutrition Co., Ltd.</p>
          <p>CEO Na-young Kim</p>
          <p>Business Registration No. 807-81-02446</p>
          <p>Telecommunications Sales Business Report No. 2022-Chungbuk Cheongju-2047</p>
          <p>123-12, Ochang Jungang-ro, Ochang-eup, Cheongwon-gu, Cheongju-si, Chungcheongbuk-do, 1-dong 402 14</p>
          <p>Representative Number: 070-8064-1032</p>
        </>
      ) : (
        <>
          <p>(주)디지털뉴트리션</p>
          <p>대표이사 김나영</p>
          <p>사업자등록번호 807-81-02446</p>
          <p>통신판매업신고 제2023-충북청주-2047호</p>
          <p>충청북도 청주시 청원구 오창읍 오창중앙로 123-12, 1동 402호 비14호</p>
          <p>대표번호 070-8064-1032</p>
        </>
      )}

      <div className="flex gap-3">
        <Link to="/app/marketing-information" className="underline ">
          {t('navigator.marketing')}
        </Link>
        <Link to="/app/privacy-policy" className="underline ">
          {t('navigator.privatePolicy')}
        </Link>
        <Link to="/app/terms-of-use" className="underline ">
          {t('navigator.useTerm')}
        </Link>
      </div>
    </footer>
  );
}
